import { s } from "../lib/constants";

export default function ResultScreen({ streaming, blocks, p1Answers, p2Answers, p1Name, p2Name, questions, onRestart }) {
  const labelBlock = blocks.find(b => b.tag === "LABEL");
  const overallBlock = blocks.find(b => b.tag === "OVERALL");
  const qBlocks = blocks.filter(b => b.tag.startsWith("Q"));

  return (
    <div style={s.step}>
      <p style={s.eyebrow}>{streaming ? "analysis running…" : "analysis complete"}</p>

      {/* STAMP */}
      {labelBlock?.content && (
        <div style={styles.stampWrapper}>
          <div style={styles.stamp}>
            <span style={styles.stampText}>{labelBlock.content}</span>
          </div>
          <p style={styles.stampSub}>{p1Name} & {p2Name}</p>
        </div>
      )}

      {/* OVERALL SUMMARY */}
      {overallBlock?.content && (
        <div style={styles.overallBox}>
          {overallBlock.content}
        </div>
      )}

      {/* PER QUESTION */}
      {qBlocks.map((block, i) => (
        <div key={i} style={styles.qBlock}>
          <div style={styles.qBlockHeader}>
            <span style={styles.qLabel}>Q{i + 1}</span>
            <span style={styles.qQuestion}>{questions[i]?.text}</span>
          </div>
          <div style={styles.qAnswerRow}>
            <div style={styles.qAnswer}>
              <span style={styles.personTag}>{p1Name}</span>
              {p1Answers?.[i]}
            </div>
            <div style={styles.qAnswer}>
              <span style={styles.personTag}>{p2Name}</span>
              {p2Answers?.[i]}
            </div>
          </div>
          <div style={styles.miniBox}>{block.content}</div>
        </div>
      ))}

      {!streaming && (
        <button style={s.btnGhost} onClick={onRestart}>start over</button>
      )}
    </div>
  );
}

const styles = {
  stampWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.75rem",
    padding: "1.5rem 0",
  },
  stamp: {
    border: "3px solid #c8924a",
    borderRadius: 4,
    padding: "1rem 2rem",
    transform: "rotate(-2deg)",
    animation: "stampIn 0.4s ease forwards",
    display: "inline-block",
    boxShadow: "0 0 0 1px #c8924a22, inset 0 0 20px #c8924a11",
  },
  stampText: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: "2rem",
    color: "#c8924a",
    fontWeight: 400,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    display: "block",
    textAlign: "center",
  },
  stampSub: {
    fontSize: "0.75rem",
    color: "#4a5a4b",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
  overallBox: {
    background: "#131a14",
    border: "1px solid #2a3a2b",
    borderRadius: 12,
    padding: "1.4rem",
    fontSize: "0.95rem",
    color: "#c8b89a",
    lineHeight: 1.8,
    whiteSpace: "pre-wrap",
  },
  qBlock: { display: "flex", flexDirection: "column", gap: "0.75rem", paddingBottom: "1.25rem", borderBottom: "1px solid #1e2a1f" },
  qBlockHeader: { display: "flex", alignItems: "baseline", gap: "0.75rem" },
  qLabel: { fontSize: "0.7rem", color: "#c8924a", letterSpacing: "0.1em", textTransform: "uppercase", flexShrink: 0 },
  qQuestion: { fontFamily: "'Cormorant Garamond', serif", fontSize: "1rem", color: "#5a6a5b", fontStyle: "italic" },
  qAnswerRow: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem" },
  qAnswer: { background: "#131a14", border: "1px solid #1e2a1f", borderRadius: 8, padding: "0.75rem", fontSize: "0.85rem", color: "#8a9a8b", lineHeight: 1.6, display: "flex", flexDirection: "column", gap: "0.3rem" },
  personTag: { fontSize: "0.65rem", color: "#c8924a", letterSpacing: "0.08em", textTransform: "uppercase", display: "block" },
  miniBox: { background: "#0a1209", border: "1px solid #1e2a1f", borderRadius: 8, padding: "0.9rem 1rem", fontSize: "0.88rem", color: "#8a9a8b", lineHeight: 1.75, whiteSpace: "pre-wrap" },
};